import { render, staticRenderFns } from "./Football.vue?vue&type=template&id=554f0b6b"
import script from "./Football.vue?vue&type=script&lang=js"
export * from "./Football.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports